// extracted by mini-css-extract-plugin
export var dropdownPopupWrapper = "navbarDropdown-module--dropdown-popup-wrapper--dda48";
export var dropdownTrigger = "navbarDropdown-module--dropdown-trigger--83d2c";
export var groupTitle = "navbarDropdown-module--group-title--6a35c";
export var hasBottomBorder = "navbarDropdown-module--has-bottom-border--44b0b";
export var plasmidIcon = "navbarDropdown-module--plasmid-icon--aa64c";
export var tubeIcon = "navbarDropdown-module--tube-icon--d1c62";